
/*数组去重*/
exports.unique = function(arr, lambda){
    if(lambda){
       arr = arr.map(lambda)
    }

    // 如果新数组的当前元素的索引值 == 该元素在原始数组中的第一个索引，则返回当前元素
    return arr.filter(function(item,index){
        return arr.indexOf(item,0) === index;
    });
}


// WEBPACK FOOTER //
// ./src/api/common.js